<ng-container *ngIf="story && story.content.component === 'root'">
  <div
    class="top-blur-overlay"
    *ngIf="blurOverlay?.filename"
    [style.background-image]="'url(' + (blurOverlay.filename | storyblokCdn) + ')'"
  >
    <div
      class="blur-bg clipped animated-top"
      *ngIf="topBlur?.filename"
      [style.background-image]="'url(' + (topBlur.filename | storyblokCdn) + ')'"
    ></div>
  </div>
  <div
    class="blur-bg clipped animated-top"
    *ngIf="!blurOverlay?.filename && topBlur?.filename"
    [style.background-image]="'url(' + (topBlur.filename | storyblokCdn) + ')'"
  ></div>

  <div class="vertical-dotted-lines" *ngIf="verticalDottedLines">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>

  <app-website-header
    [color]="darkHeader ? 'dark' : undefined"
    [hideNav]="!story.content.showNavigation || hideHeaderNav"
    [customCta]="customCta"
  >
    <ng-content select="[headerCta]"></ng-content>
  </app-website-header>
  <article
    [appStoryblok]="story.content._editable"
    class="storyblok-page"
    [class.with-spacing]="!hasHomeTeaser"
    [class.dark]="story.content.background === 'dark' || story.content.background === 'black'"
    [class.black]="story.content.background === 'black'"
  >
    <app-top-gradient
      *ngIf="story.content.topGradient && story.content.topGradient !== 'none'"
      [gradient]="story.content.topGradient"
    ></app-top-gradient>
    <ndc-dynamic
      *ngFor="let blok of story.content['body']; trackBy: trackByFunction"
      [ndcDynamicComponent]="$any(storyblokService.components[blok.component])"
      [ndcDynamicInputs]="dynamicInputs(blok)"
    ></ndc-dynamic>
  </article>

  <app-pre-footer
    *ngIf="prefooter"
    [dark]="['dark', 'black'].includes(story.content.background)"
    [black]="story.content.background === 'black'"
    [lightImage]="prefooter.image?.filename | storyblokCdn"
    [darkImage]="prefooter.image?.filename | storyblokCdn"
    [appStoryblok]="prefooter._editable"
  >
    <a
      [appStoryblok]="prefooter.cta[0]._editable"
      [routerLink]="prefooter.cta[0].link"
      appButton
      name="signup-cta"
      location="pre-footer"
      color="primary"
      height="4"
      spacing="4"
      size="3"
      weight="default"
      shape="round"
      [center]="true"
    >
      <b>{{ prefooter.cta[0].text }}</b>
    </a>
  </app-pre-footer>
  <app-website-footer
    *ngIf="story.content.showNavigation"
    [dark]="story.content.background === 'dark' || story.content.background === 'black'"
    [black]="story.content.background === 'black'"
  ></app-website-footer>
</ng-container>

<ng-container *ngIf="story && story.content.component !== 'root'">
  <ndc-dynamic
    [ndcDynamicComponent]="$any(storyblokService.components[story.content.component])"
    [ndcDynamicInputs]="story.content"
  ></ndc-dynamic>
</ng-container>

@defer (when !story) {
<ng-container *ngIf="!story">
  <app-website-header></app-website-header>
  <app-not-found bgChars="404" errorTitle="Not Found">
    Whoops! It looks like this page does not exist anymore. Try going back to our homepage.

    <a
      [routerLink]="['/']"
      appButton
      name="home"
      location="404-page"
      color="primary"
      spacing="4"
      shape="round"
      height="3"
      [center]="true"
      >Back to Home</a
    >
  </app-not-found>
  <app-website-footer></app-website-footer>
</ng-container>
}
